<template>
  <layout>
    <div v-if="loadingHeader" class="dot-opacity-loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <section v-else class="devices-settings m-md-5 m-1">
      <div v-for="question in questions" :key="question.id" role="tablist">
        <div class="shadow-card mx-3 mx-md-0">
          <div
            v-if="question && question.header && question.id"
            v-b-toggle="'accordion' + question.id"
            variant="transparent"
            class="py-4 px-4 px-md-5 mt-3 d-flex justify-content-between"
            @click="loadAnswer(question.id)"
          >
            <div>
              {{ question.header }}
            </div>
            <div>
              <svg-icon
                v-show="collapse[question.id]"
                size="24"
                name="chevron-up"
                class="fill-icon mr-2 icon-light"
              ></svg-icon>
              <svg-icon
                v-show="!collapse[question.id]"
                size="24"
                name="chevron-down"
                class="fill-icon mr-2"
              ></svg-icon>
            </div>
          </div>
          <b-collapse
            :id="`accordion` + question.id"
            v-model="collapse[question.id]"
            class="minCollapseHeight pb-3 px-3 p-md-0 mx-0 mx-md-5"
          >
            <div v-if="loadingAnswerDictionary[question.id]" class="dot-opacity-loader">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div v-else id="forImage" class="mx-0 mx-md-5 px-0 px-md-5 pb-4">
              <div v-html="answersDictionary[question.id]"></div>
            </div>
          </b-collapse>
        </div>
      </div>
      <div class="my-5 px-5">
        <p class="text-white">
          {{ $t('faq.contactUs1') }}
          <router-link class="text-white" :to="{ name: 'SupportRequests' }">
            <u>{{ $t('faq.contactUs2') }}</u>
          </router-link>
          {{ $t('faq.contactUs3') }}
        </p>
      </div>
    </section>
  </layout>
</template>

<script>
import faqQuestions from '@/api/faq/faqQuestions.gql';
import faqAnswers from '@/api/faq/faqAnswers.gql';
import { i18n } from '@/plugins/i18n';
import { vueWindowSizeMixin } from 'vue-window-size';

export default {
  name: 'Faq',
  mixins: [vueWindowSizeMixin],
  apollo: {
    questions: {
      query: faqQuestions,
      variables() {
        return {
          lang: this.locale,
          type: this.faqBreakpoint,
        };
      },
      update(data) {
        const faqQuestions = data.koeeBoxQuery.faqItems;

        return faqQuestions;
      },
      skip() {
        return !i18n.locale;
      },
    },
  },
  data() {
    return {
      collapse: {},
      loadingAnswerDictionary: {},
      answersDictionary: {},
    };
  },
  computed: {
    loadingHeader() {
      return this.$apollo.queries.questions.loading;
    },
    faqBreakpoint() {
      return this.size ? 'DESKTOP' : 'MOBILE';
    },
    size() {
      return this.windowWidth > 775;
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    locale() {
      this.answersDictionary = {};
      this.$apollo.queries.questions.refetch({ lang: this.locale, type: this.faqBreakpoint });
    },
  },
  methods: {
    contacts() {
      return this.$router.push({ name: 'SupportRequests' });
    },
    loadAnswer(id) {
      if (id in this.answersDictionary) {
        return this.answersDictionary[id];
      }

      this.$set(this.loadingAnswerDictionary, id, true);

      this.$apollo
        .query({
          query: faqAnswers,
          variables: {
            id: id,
            lang: this.locale,
          },
        })
        .then((r) => {
          this.$set(this.answersDictionary, id, r.data.koeeBoxQuery.faqItemContent);
          this.$set(this.loadingAnswerDictionary, id, false);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.minCollapseHeight {
  min-height: 75px;
}
span img {
  background: red;
}
#forImage {
  ::v-deep img {
    border: 1px solid #707381;
    border-radius: 5px;
    box-sizing: border-box;
    max-width: 100% !important;
  }
}
</style>
